import { getCompanyInfo, choiceCompany } from "@/services/api_company";

import userInfoStore from "@/store/user.store";
import { CompanyInfo } from "@/types/company";
import { message } from "antd";


class CompanyHelper {

  // 获取企业信息
  public static async getCompanyInfo(): Promise<{ list: CompanyInfo[], currId: string }> {
    const res = await getCompanyInfo();
    const currCompanyId = userInfoStore.getState().company.companyId;

    // 对结果进行排序，将当前公司排在前面
    // const sortedList = res.sort((a, b) => {
    //   if (a.companyId === currCompanyId) return -1;
    //   if (b.companyId === currCompanyId) return 1;
    //   return 0;
    // });

    return { list: res, currId: currCompanyId };
  }

  // 选择企业
  public static async choiceCompany(identityId: string, cb: () => void) {
    const res = await choiceCompany(identityId);
    if (res) {
      cb();
    } else {
      console.log(res);
      message.error('切换企业失败');
    }
  }

  // 切换企业
  private static isSwitching = false;

  public static async switchCompany(identityId: string) {
    if (this.isSwitching) {
      console.log('正在切换，返回');
      return;
    }
    this.isSwitching = true;
    // 唯一检测ID
    const checkKey = 'company-tab-check';
    const responseKey = 'company-tab-response';
    const checkId = `${Date.now()}_${Math.random()}`;

    let hasOtherTab = false;

    // 监听响应
    function onStorage(e: StorageEvent) {
      if (e.key === responseKey && e.newValue === checkId) {
        hasOtherTab = true;
      }
    }
    window.addEventListener('storage', onStorage);

    localStorage.setItem(checkKey, checkId);  // 发起检测

    // 等待200ms收集响应
    await new Promise(resolve => setTimeout(resolve, 100));

    window.removeEventListener('storage', onStorage);
    localStorage.removeItem(checkKey);

    if (hasOtherTab) {
      message.error('检测到有其他标签页已打开本系统，请关闭其他标签页后再切换企业。');
      this.isSwitching = false;
      return;
    }

    const res = await choiceCompany(identityId);
    if (res) {
      message.success('已切换到新的企业');
      setTimeout(() => {
        this.isSwitching = false;
        location.reload();
      }, 500);
    } else {
      console.log(res);
      message.error('切换企业失败');
      this.isSwitching = false;
    }
  }


  // 是否只有个人端
  public static async onlyPersonal(): Promise<boolean> {
    const res = await getCompanyInfo();

    let isOnlyPersonal = false;
    if (res.length === 1) {
      isOnlyPersonal = res[0].identityType === 0; // 个人账号类型等于0
    } else {
      isOnlyPersonal = false;
    }

    return isOnlyPersonal;
  }

  public static async onlyOneCompany(): Promise<{ isOnlyOneCompany: boolean, companyId: string }> {
    const res = await getCompanyInfo();
    let isOnlyOneCompany = false;
    let companyId = '';
    if (res.length === 1) {
      isOnlyOneCompany = res[0].identityType === 1; // 企业账号类型等于1
      companyId = res[0].identityId;
    } else {
      isOnlyOneCompany = false;
    }
    return { isOnlyOneCompany, companyId };
  }
}

export default CompanyHelper;